import React from 'react';

import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';


class ConfirmacaoCadastroCliente extends React.Component {

  constructor(props) {
      super(props);

      this.state = {
          acesso: {},
          lemmbrar: false
      }
  }

  componentDidMount(){    
   
  }

  render() {
      return(
          <div className='app-pre-cadastro'>
                <div>
                    <div className='app-pre-cadastro-quadro'>
                        <div className="flex align-items-center">
                            <img src={require("../img/coroa.webp")} style={{width: '40px'}} />
                            <span style={{marginLeft: '10px'}} />
                            <span style={{fontSize: '30px'}} className='app-titulo'>VILLA OURO</span>
                        </div>

                        
                            

                        
                            <div >
                                <div style={{textAlign: 'center', marginTop: '20px', marginBottom: '2px'}}>
                                    <h1>
                                        PRÉ CADASTRO REALIZADO
                                    </h1>
                                </div>
                                
                                <div>
                                    <p>
                                        &nbsp; &nbsp; Seu cadastro foi realizado com sucesso, agora é só aguardar que entraremos em contato para formalizar os seu cadastro.
                                    </p>
                                    <p>
                                        Obrigado pela preferência.
                                    </p>
                                </div>

                                <div style={{marginTop: '20px', height: '38px'}}>
                                    <Button label="ENTRAR" className='app-background-gold' style={{float: 'right'}} onClick={() => window.location.href = '/entrar'}/>
                                </div>
                            </div>
                        
                    </div> 
                    

                        
                        
                        
                    
                    
                    
                </div>
        </div>
      );
      
  }


}
export default ConfirmacaoCadastroCliente;
